import { Injectable }         from '@angular/core';
import { Http, Response }     from '@angular/http';
import { Observable }         from 'rxjs/Observable';
import { ConfigService }      from '../configuracion/config.service';
import { RequestBaseService } from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class TipoMaquinaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'tipo-maquina'].join('/');
  }

  public getActividadesByTipoMaquina(tipomaquina_id: number): Observable<any> {
    return this.http.get([
      this.ApiUrl,
      tipomaquina_id,
      'actividad'
    ].join('/'))
    .map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/tipo-maquina/tipo-maquina.service.ts